var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: { shadow: "never", "body-style": { padding: "18px 22px" } },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目搜索" } },
                [
                  _c("el-input", {
                    staticClass: "search-input",
                    attrs: {
                      clearable: "",
                      placeholder: "项目编号 / 工地 / 客户 / 手机 / 小区",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "项目状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待开工", value: "pending_start" },
                      }),
                      _c("el-option", {
                        attrs: { label: "施工中", value: "in_progress" },
                      }),
                      _c("el-option", {
                        attrs: { label: "待软装", value: "construction_done" },
                      }),
                      _c("el-option", {
                        attrs: { label: "验收中", value: "acceptance" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已竣工", value: "completed" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "summary-grid" }, [
        _c("div", { staticClass: "summary-card" }, [
          _c("span", [_vm._v("当前页项目")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.data.length))]),
          _c("small", [_vm._v("PROJECTS")]),
        ]),
        _c("div", { staticClass: "summary-card amber" }, [
          _c("span", [_vm._v("待开工")]),
          _c("strong", [_vm._v(_vm._s(_vm.statusCount("pending_start")))]),
          _c("small", [_vm._v("READY TO START")]),
        ]),
        _c("div", { staticClass: "summary-card soft" }, [
          _c("span", [_vm._v("待软装")]),
          _c("strong", [_vm._v(_vm._s(_vm.statusCount("construction_done")))]),
          _c("small", [_vm._v("SOFT FURNISHING")]),
        ]),
        _c("div", { staticClass: "summary-card green" }, [
          _c("span", [_vm._v("施工中")]),
          _c("strong", [_vm._v(_vm._s(_vm.statusCount("in_progress")))]),
          _c("small", [_vm._v("IN PROGRESS")]),
        ]),
        _c("div", { staticClass: "summary-card done" }, [
          _c("span", [_vm._v("已竣工")]),
          _c("strong", [_vm._v(_vm._s(_vm.statusCount("completed")))]),
          _c("small", [_vm._v("COMPLETED")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "list-title" },
            [
              _c("div", [
                _c("strong", [_vm._v("工地项目台账")]),
                _c("span", [
                  _vm._v("共 " + _vm._s(_vm.tableData.total) + " 个工地"),
                ]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "expand-panel" }, [
                          _c("div", [
                            _c("span", [_vm._v("详细地址")]),
                            _c("strong", [
                              _vm._v(_vm._s(row.project.addressDetail || "--")),
                            ]),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("装修合同")]),
                            _c("strong", [
                              _vm._v(
                                _vm._s(row.contract.contractNo) +
                                  " · ¥" +
                                  _vm._s(
                                    _vm.formatMoney(row.contract.contractAmount)
                                  )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "team-row" }, [
                            _c("span", [_vm._v("项目团队")]),
                            _c(
                              "div",
                              _vm._l(row.members, function (member) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: member.id,
                                    attrs: { size: "mini", effect: "plain" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.roleText[member.projectRole] ||
                                          member.projectRole
                                      ) +
                                        " · " +
                                        _vm._s(member.staffName || "--")
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ]),
                          row.project.startRemark
                            ? _c("div", [
                                _c("span", [_vm._v("开工说明")]),
                                _c("strong", [
                                  _vm._v(_vm._s(row.project.startRemark)),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "项目编号", "min-width": "205" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "project-no" }, [
                          _vm._v(_vm._s(row.project.projectNo)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工地项目", "min-width": "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "project-name" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.project.projectName)),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(row.property.communityName || "--")),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "客户", "min-width": "125" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "project-name" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.lead.name || row.customer.name)),
                          ]),
                          _c("span", [_vm._v(_vm._s(row.lead.mobile))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "95" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTag[row.project.status] || "info",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.statusText[row.project.status] ||
                                  row.project.status
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "计划周期", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(row.project.plannedStartDate) +
                              " 至 " +
                              _vm._s(row.project.plannedEndDate)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工长", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.memberName(row, "foreman")))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "设计师", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.memberName(row, "designer")))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "监理", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.memberName(row, "supervisor")))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "实际开工", "min-width": "165" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(row.project.actualStartTime || "--")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "合同金额",
                  "min-width": "125",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("strong", { staticClass: "money" }, [
                          _vm._v(
                            "¥" +
                              _vm._s(
                                _vm.formatMoney(row.contract.contractAmount)
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-hero" }, [
      _c("div", [
        _c("span", { staticClass: "eyebrow" }, [
          _vm._v("PROJECT DELIVERY CENTER"),
        ]),
        _c("h2", [_vm._v("装修工地交付中心")]),
        _c("p", [
          _vm._v("从首款结清到正式开工，统一查看项目计划、地址和责任团队。"),
        ]),
      ]),
      _c("div", { staticClass: "hero-mark" }, [_vm._v("工地")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }